<app-table-form-container
	[loading]="loading()"
	modelName="Unit"
	[showForm]="isFormShowing()"
	(onShowForm)="onShowForm()"
	(onHideForm)="onHideForm()"
>
	<ng-template #tableTemplate>
		<app-cms-table
			[tableKey]="'unit-list'"
			[loading]="loading()"
			[rows]="units()"
			[columns]="columns()"
			[selectedUuid]="editUnit()?.uuid"
			[uuidsInProgress]="uuidsInProgress()"
			(onSelect)="select($event)"
			(onCopy)="copy($event)"
			(onCopyBulk)="copyBulk($event)"
			(onEdit)="edit($event)"
			(onDelete)="delete$($event)"
			(onMoveUp)="moveUp$($event)"
			(onMoveDown)="moveDown$($event)"
		>
			<!-- Header templates (defines order/keys) -->
			<ng-template appHeaderColumn="unitName">Unit</ng-template>

			<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
			<ng-template appRowColumn="unitName" let-row>
				<div class="name-column clickable">
					{{ row.active_text.name }}
				</div>
			</ng-template>
		</app-cms-table>
	</ng-template>

	<ng-template #formTemplate>
		<nz-card>
			<app-language-selector (onChange)="onEditLanguageChange($event)"></app-language-selector>
			<app-unit-form
				[unit]="editUnit()"
				[editLanguage]="editLanguage()"
				(onSubmit)="onUnitFormSubmit$($event)"
			></app-unit-form>
		</nz-card>
	</ng-template>
</app-table-form-container>
